import React, { useState } from 'react';
import { TextField, Box, InputAdornment, FormControl, IconButton } from '@mui/material';
import { useTheme } from '@emotion/react';
import LockIcon from '@mui/icons-material/Lock';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const PasswordInput = ({ type, placeholder, onChange, name, required, value }) => {
    const theme = useTheme();
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    return (
        <>
            <FormControl fullWidth variant="outlined" sx={{ backgroundColor: theme.palette.background.input }}>
                <TextField
                    id={name}
                    type={showPassword ? 'text' : 'password'}
                    placeholder={placeholder}
                    required={required}
                    value={value}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LockIcon />
                                {/* الخط الرأسي بين الكود ورقم الهاتف */}
                                <Box
                                    sx={{
                                        width: '1px',
                                        height: '24px',
                                        backgroundColor: theme.palette.divider,
                                        mx: 1
                                    }}
                                />
                            </InputAdornment>
                        ),
                        endAdornment: ( // أيقونة القفل على اليمين
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    edge="start"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    // تنسيق الحقل لجعل الحدود حول TextField فقط
                    sx={{
                        '& .MuiOutlinedInput-input': {
                            paddingLeft: 0,
                            textAlign: 'left',
                            height: '10px',
                            '&::placeholder': {
                                textAlign: 'left', // هذا السطر يجعل الـ placeholder يبدأ من اليمين
                            },
                        }
                    }}
                    label="" // إزالة الليبل الصغير الداخلي
                    name={name}
                    onChange={onChange}
                />
            </FormControl>
        </>
    )
}

export default PasswordInput;
